// Listing search
export const LISTING_SEARCH_OPEN = 'listing-search-open'
export const LISTING_SEARCH_RESULTS = 'listing-search-results'
export const LISTING_SEARCH_FILTER_OPEN = 'listing-search-filter-open'
export const LISTING_SEARCH_FILTER_CLOSE = 'listing-search-filter-close'
export const LISTING_SEARCH_FILTER_CLEAR = 'listing-search-filter-clear'
export const LISTING_SEARCH_FILTER_APPLY = 'listing-search-filter-apply'
